// Every custom event the site sends. Keeping the union closed means a typo is a
// compile error rather than an event that silently never appears in a report.
export type AnalyticsEvent =
  | 'article-view'
  | 'article-scroll'
  | 'article-cta-click'
  | 'contact-submit';

type UmamiTracker = { track: (event: string, data?: object) => void };

declare global {
  interface Window {
    umami?: UmamiTracker;
  }
}

// Fire-and-forget. The tracker is absent in dev, in Jest, and in any ad-blocked
// browser — analytics must never be able to break a render path, so every failure
// mode here is a silent no-op.
export function track(
  event: AnalyticsEvent,
  data?: Record<string, string | number>
): void {
  try {
    window.umami?.track(event, data);
  } catch {
    /* tracker blocked or broken — not our problem to surface */
  }
}
